import IconTick from "app/components/Icon/components/IconTick/IconTick";
import { FormattedMessage } from "react-intl";

type PasswordValidationCriteriaProps = {
  passwordHasLowerAndUpperCase: boolean;
  passwordHasNumber: boolean;
  passwordHasSpecialChar: boolean;
  passwordHasMinLength: boolean;
  password: string;
};

const PasswordValidationCriteria: React.FC<PasswordValidationCriteriaProps> = ({
  passwordHasLowerAndUpperCase,
  passwordHasNumber,
  passwordHasSpecialChar,
  passwordHasMinLength,
  password,
}) => {
  return (
    <div
      className={`form-details__row--info form-details__row--validation-messages ${
        password.length === 0 ? "error" : ""
      }`}
    >
      <span
        className={`form-details__row--validation-message ${
          passwordHasMinLength ? "validated" : ""
        }`}
      >
        <IconTick />
        <FormattedMessage tagName="span" id="register-account-password-min" />
      </span>
      <span
        className={`form-details__row--validation-message ${
          passwordHasLowerAndUpperCase ? "validated" : ""
        }`}
      >
        <IconTick />
        <FormattedMessage
          tagName="span"
          id="register-account-password-letters"
        />
      </span>
      <span
        className={`form-details__row--validation-message ${
          passwordHasNumber ? "validated" : ""
        }`}
      >
        <IconTick />
        <FormattedMessage
          tagName="span"
          id="register-account-password-number"
        />
      </span>
      <span
        className={`form-details__row--validation-message ${
          passwordHasSpecialChar ? "validated" : ""
        }`}
      >
        <IconTick />
        <FormattedMessage
          tagName="span"
          id="register-account-password-symbols"
        />
      </span>
    </div>
  );
};

export default PasswordValidationCriteria;
